import { useState, type FC } from "react";

import TelegramIcon from "@mui/icons-material/Telegram";
import { Button, TextField } from "@mui/material";

import { organizationManagerRepo } from "@repositories";
import { useAlert } from "clients/admin/src/desktop/contexts/AlertProvider";
import { useUser } from "clients/admin/src/desktop/contexts/UserProvider";
import "./SendInDistribution.scss";

interface SendInDistributionProps {
  users: string[];
  setIsPopupOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const SendInDistribution: FC<SendInDistributionProps> = ({
  users,
  setIsPopupOpen,
}) => {
  const [content, setContent] = useState<string>("");
  const { setAlertText, setSeverity } = useAlert();
  const { currentUser } = useUser();

  async function handleSend() {
    if (!content || users.length <= 0) return;
    const sender = await organizationManagerRepo.findOne({
      where: { id: currentUser?.id },
      include: { organization: true },
    });

    // TODO: handle the send? what to do here?

    setSeverity("success");
    setAlertText("ההודעה נשלחה בהצלחה");
    if (setIsPopupOpen) setIsPopupOpen(false);
  }

  return (
    <div className="send-in-distribution-container">
      <div className="send-in-distribution-content">
        <TextField
          multiline
          maxRows={10}
          value={content}
          onChange={(event) => setContent(event.target.value)}
          className="send-in-distribution-input"
          placeholder="הכניסו את תוכן ההודעה ולחצו על כפתור השליחה"
          aria-label="תוכן ההודעה"
        />
      </div>
      <Button className="send-message-button" onClick={handleSend}>
        <TelegramIcon />
        שליחת הודעה
      </Button>
    </div>
  );
};
